import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=561d33ba&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561d33ba')) {
      api.createRecord('561d33ba', component.options)
    } else {
      api.reload('561d33ba', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=561d33ba&", function () {
      api.rerender('561d33ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/menu.vue"
export default component.exports